import GiveButton from './GiveButton';
import GiveButtonContainer from './GiveButton.container';

export default GiveButtonContainer(GiveButton);